import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {ShowModelPayload} from '../../../types'
import {testIdProps} from '@github-ui/test-id-props'
import {VerifiedHTMLBox} from '@github-ui/safe-html/VerifiedHTML'

export function Transparency() {
  const {modelTransparencyContent} = useRoutePayload<ShowModelPayload>()

  return (
    <VerifiedHTMLBox
      data-hpc
      className="pr-p-3"
      html={modelTransparencyContent}
      {...testIdProps('transparency-content')}
    />
  )
}
